<template>
  <div>
    <v-card>
      <v-card-title class="headline">
        <a
          :href="`http://vmcrm.quanlyxe.vn/index.php?module=Cases&action=DetailView&record=${Case.Id}`"
          target="_blank"
        >Case {{ Case.CaseNumber }}</a>

        <v-spacer></v-spacer>
        <v-btn
          round
          color="success"
          dark
          v-show="isCanDispatch(Case)"
          @click="dispatch()"
        >Điều phối</v-btn>
      </v-card-title>
      <v-card-text>
        <v-card>
          <v-card-title primary-title>Overview</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs6 class="text">
                <v-icon>directions_car</v-icon>
                Vehicle: {{ Case.Vehicle }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>code</v-icon>
                Case Number: {{ Case.CaseNumber }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>location_on</v-icon>
                TrackingID: {{ Case.TrackingID }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>build</v-icon>
                Status: {{ Case.Status }}
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>&nbsp;
        <v-card>
          <v-card-title primary-title>Repair</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs6 class="text">
                <v-icon>contacts</v-icon>
                Driver Contact: {{ Case.DriverContact }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>person</v-icon>
                Repair Person: {{ Case.RepairPerson }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>location_on</v-icon>
                Repair Location: {{ Case.RepairLocation }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>location_on</v-icon>Location:
                <a
                  :href="`https://www.google.com/maps?q=${Case.Location}`"
                  target="_blank"
                >{{ Case.Location}}</a>
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>access_time</v-icon>
                Installation Time Expected: {{ Case.InstallationTimeExpected }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>access_time</v-icon>
                Installation Duration: {{ Case.InstallationDuration }} (minutes)
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>date_range</v-icon>
                Plan: {{ formatGMTToLocalTime(Case.Plan)}}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>date_range</v-icon>
                Finished: {{ formatGMTToLocalTime(Case.Finished)}}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>error</v-icon>
                Error Type: {{ Case.ErrorType }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>attach_money</v-icon>
                Repair Cost: {{ Case.RepairCost }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>attach_money</v-icon>
                Customer Charge: {{ Case.CustomerCharge }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>phone_android</v-icon>
                Last Viewed (By phone): {{ Case.LastViewedByPhone }}
              </v-flex>
              <v-flex xs12 class="text">
                <v-icon>history</v-icon>
                WorkLog: {{ Case.WorkLog }}
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>&nbsp;
        <v-card>
          <v-card-title primary-title>Other</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs6 class="text">
                <v-icon>person</v-icon>
                Created By: {{ Case.CreatedBy }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>date_range</v-icon>
                Created: {{ formatGMTToLocalTime(Case.Created) }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>person</v-icon>
                Modified By Name: {{ Case.ModifiedByName }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>date_range</v-icon>
                Date Modified: {{ formatGMTToLocalTime(Case.DateModified) }}
              </v-flex>
              <v-flex xs6 class="text">
                <v-icon>person</v-icon>
                Assigned To: {{ Case.AssignedTo }}
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
    <!-- Dialog -->
    <div class="text-xs-center">
      <v-dialog v-model="isDispatching" fullscreen lazy scrollable>
        <v-card>
          <div v-if="isDispatching">
            <overview
              :selectedCase="Case"
              :supporters="supporters"
              @display="hideDispatch($event)"
            />
          </div>
        </v-card>
      </v-dialog>
    </div>
    <!-- End Dialog -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Overview from '@/pages/dispatch/Overview';
import moment from 'moment';
import { formatGMTToLocalTime } from '@/utils/datetime';

export default {
  components: {
    Overview
  },
  props: {
    Case: Object
  },
  data () {
    return {
      isDispatching: false,
      moment: moment,
      userCanDispatch: [
        'trinm@vietmap.vn',
        'trivm@vietmap.vn',
        'thuongnh@vietmap.vn',
        'trinhtp@vietmap.vn',
        'nguyendt@vietmap.vn',
        'vinhlc@vietmap.vn',
        'luantv@vietmap.vn',
        'nhungtt@vietmap.vn',
        'thiennh@vietmap.vn',
        'thanhhh@vietmap.vn',
        'anhtq@vietmap.vn'
      ]
    };
  },
  computed: {
    ...mapGetters(['supporters', 'loggedUser'])
  },
  methods: {
    formatGMTToLocalTime,
    ...mapMutations(['SET_SELECTED_CASES']),
    dispatch (c) {
      this.SET_SELECTED_CASES(c);
      this.isDispatching = true;
    },
    hideDispatch (isShow) {
      this.isDispatching = isShow;
      this.$emit('display', false);
    },
    isCanDispatch (c) {
      return !c.RepairPerson && this.userCanDispatch.includes(this.loggedUser && this.loggedUser.Email);
    }
  }
};
</script>
<style scoped>
.v-icon {
  padding-right: 24px;
  font-size: 16pt;
  padding-left: 24px;
}
.work-log {
  line-height: 24pt !important;
}
.text {
  padding-bottom: 8px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/crm/CaseDetail.vue